import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

function ProductFormModal({
  show,
  onHide,
  isEditing,
  formData,
  setFormData,
  setSelectedFile,
  onSubmit,
  isSaving,
}) {
  return (
    <Modal show={show} onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditing ? "Edit Product" : "Add New Product"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Product Name *</Form.Label>
            <Form.Control
              type="text"
              required
              value={formData.product_name}
              onChange={(e) =>
                setFormData({ ...formData, product_name: e.target.value })
              }
            />
          </Form.Group>

          <div className="row">
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>MRP (₹) *</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  required
                  value={formData.product_price}
                  onChange={(e) =>
                    setFormData({ ...formData, product_price: e.target.value })
                  }
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Selling Price (₹)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Optional"
                  value={formData.product_discount_price || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, product_discount_price: e.target.value })
                  }
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Weight / Unit *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g. 500g, 1L, 1 Box"
                  required
                  value={formData.product_weight}
                  onChange={(e) =>
                    setFormData({ ...formData, product_weight: e.target.value })
                  }
                />
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Product Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setSelectedFile(e.target.files[0])}
              // Removed the required attribute here!
            />
            {isEditing && (
              <small className="text-muted">
                Leave empty to keep existing image.
              </small>
            )}
            {!isEditing && <small className="text-muted">Optional.</small>}
          </Form.Group>
          
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Sequence</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.product_sequence}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      product_sequence: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={formData.is_active}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      is_active: Number(e.target.value),
                    })
                  }
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </Form.Select>
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="success" type="submit" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Product"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ProductFormModal;
